import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Physically Disabled")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Start Date ", -1)
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "End Date ", -1)
const _hoisted_15 = { class: "col-md-3 mt-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "table-responsive mt-5" }
const _hoisted_19 = {
  style: {"float":"right"},
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_28 = { class: "table table-borderless gy-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      rowspan: "1"
    }, " SL "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      rowspan: "1"
    }, " Training Partner "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      rowspan: "1"
    }, " Total Disabled "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      rowspan: "1"
    }, " Male "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      rowspan: "1"
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      rowspan: "1"
    }, " Female(%) ")
  ])
], -1)
const _hoisted_30 = {
  style: {"border":"1px solid black !important","text-align":"center"},
  class: "align-middle"
}
const _hoisted_31 = {
  style: {"border":"1px solid black !important","text-align":"center"},
  class: "align-middle"
}
const _hoisted_32 = {
  style: {"border":"1px solid black !important","text-align":"center"},
  class: "align-middle"
}
const _hoisted_33 = {
  style: {"border":"1px solid black !important","text-align":"center"},
  class: "align-middle"
}
const _hoisted_34 = {
  style: {"border":"1px solid black !important","text-align":"center"},
  class: "align-middle"
}
const _hoisted_35 = {
  style: {"border":"1px solid black !important","text-align":"center"},
  class: "align-middle"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", {
  style: {"border":"1px solid black !important","text-align":"center"},
  class: "align-middle font-weight-bold"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", {
  style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"},
  class: "align-middle font-weight-bold"
}, " Total ", -1)
const _hoisted_38 = {
  style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"},
  class: "align-middle font-weight-bold"
}
const _hoisted_39 = {
  style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"},
  class: "align-middle font-weight-bold"
}
const _hoisted_40 = {
  style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"},
  class: "align-middle font-weight-bold"
}
const _hoisted_41 = {
  style: {"border":"1px solid black !important","text-align":"center","font-weight":"bold"},
  class: "align-middle font-weight-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[7] || (_cache[7] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      options: _ctx.optionsTranche,
                      mode: "tags",
                      "clear-on-select": false,
                      placeholder: "Select Tranche",
                      "close-on-select": false,
                      searchable: true,
                      "create-option": true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_el_form_item, {
                      prop: "date",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.batch.start_date,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.start_date) = $event)),
                          "value-format": "YYYY-MM-DD",
                          format: "DD-MM-YYYY",
                          type: "date",
                          name: "start_date",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_el_form_item, {
                      prop: "date",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.batch.end_date,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.end_date) = $event)),
                          "value-format": "YYYY-MM-DD",
                          format: "DD-MM-YYYY",
                          type: "date",
                          name: "end_date",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trainingProviderNotice())),
                      type: "button",
                      class: "btn btn-success mt-6 p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_16
                    ])
                  ])
                ]),
                (_ctx.showCourseNotice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                            title: "Download Xlse",
                            "data-v-54b12dc8": "",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportTrainee()))
                          }, _hoisted_21),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                            title: "Download PDF",
                            "data-v-54b12dc8": "",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downloadPdf()))
                          }, _hoisted_23),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                            title: "Print",
                            "data-v-54b12dc8": "",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printPdf()))
                          }, _hoisted_25),
                          _hoisted_26,
                          _hoisted_27
                        ]),
                        _createElementVNode("table", _hoisted_28, [
                          _hoisted_29,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (info, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                class: "bg-light fs-7 t align-middle",
                                key: index,
                                style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51)"}
                              }, [
                                _createElementVNode("td", _hoisted_30, _toDisplayString(info?.sl), 1),
                                _createElementVNode("td", _hoisted_31, _toDisplayString(info?.entity_short_name), 1),
                                _createElementVNode("td", _hoisted_32, _toDisplayString(+info?.male + +info?.female), 1),
                                _createElementVNode("td", _hoisted_33, _toDisplayString(info?.male), 1),
                                _createElementVNode("td", _hoisted_34, _toDisplayString(info?.female), 1),
                                _createElementVNode("td", _hoisted_35, _toDisplayString(info?.total_disabled != 0
                            ? (
                              (info?.female / info?.total_disabled) *
                              100
                            ).toFixed(2)
                            : 0), 1)
                              ]))
                            }), 128)),
                            _createElementVNode("tr", null, [
                              _hoisted_36,
                              _hoisted_37,
                              _createElementVNode("td", _hoisted_38, _toDisplayString(+_ctx.total?.male + +_ctx.total?.female), 1),
                              _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.total?.male), 1),
                              _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.total?.female), 1),
                              _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.total?.total_disabled != 0
                            ? (
                              (_ctx.total?.female / _ctx.total?.total_disabled) *
                              100
                            ).toFixed(2)
                            : 0), 1)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}